/**
 * Injects a product image/title/CTA row as the first <tr> in tables inside
 * .comparison-table__content (metafield HTML with <table><tbody>…):
 * empty label cell, then three product cells.
 */
(function () {
  /**
   * Content-box height of the cell (where the inner wrapper sits).
   * Prefer offsetHeight over getBoundingClientRect: rect + padding math can be short
   * vs table layout, leaving a strip under the inner while vertical-align is top.
   */
  function productTdContentBoxHeight(td) {
    var st = getComputedStyle(td);
    var bt = parseFloat(st.borderTopWidth) || 0;
    var bb = parseFloat(st.borderBottomWidth) || 0;
    var pt = parseFloat(st.paddingTop) || 0;
    var pb = parseFloat(st.paddingBottom) || 0;
    return Math.max(0, td.offsetHeight - bt - bb - pt - pb);
  }

  function setupProductRowCellStretch(tr) {
    function sync() {
      var productTds = tr.querySelectorAll('td.comparison-table__product');
      var maxH = 0;
      productTds.forEach(function (td) {
        maxH = Math.max(maxH, productTdContentBoxHeight(td));
      });
      if (maxH <= 0) return;
      var h = Math.round(maxH);
      productTds.forEach(function (td) {
        var inner = td.querySelector('.we-comparison-table__product-cell');
        if (inner) {
          inner.style.minHeight = '';
          inner.style.height = h + 'px';
        }
      });
    }

    var rafId;
    function scheduleSync() {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function () {
        rafId = requestAnimationFrame(sync);
      });
    }

    scheduleSync();

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(scheduleSync);
      ro.observe(tr);
      tr.querySelectorAll('td.comparison-table__product').forEach(function (td) {
        ro.observe(td);
      });
    }

    window.addEventListener('resize', scheduleSync);

    tr.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', scheduleSync);
      }
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleSync);
    }

    window.addEventListener('load', scheduleSync);
  }

  function createLabelCell() {
    const td = document.createElement('td');
    td.className = 'td-label background-1 text-body';
    return td;
  }

  function createProductCell(product, productIndex, payload) {
    const td = document.createElement('td');
    td.className = 'comparison-table__product';

    const placeholderImage = payload.placeholderImage || '';
    const imgSrc = product.image && product.image.length ? product.image : placeholderImage;
    const productUrl = product.url && product.url.length ? product.url : '#';
    const title = product.title || '';

    const labelCurrent = payload.buttonLabelCurrentProduct || '';
    const labelOther = payload.buttonLabelOtherProducts || '';
    const buttonLabel = productIndex === 0 ? labelCurrent : labelOther;

    const buttonHtml =
      productIndex === 0
        ? `<button type="button" class="btn btn--primary" disabled aria-disabled="true"><span class="btn__text">${escapeHtml(buttonLabel)}</span></button>`
        : `<a class="btn btn--primary" href="${escapeAttr(productUrl)}"><span class="btn__text">${escapeHtml(buttonLabel)}</span></a>`;

    td.innerHTML = [
      '<div class="we-comparison-table__product-cell">',
      '<div class="product-featured-image relative">',
      '  <div class="media-wrapper hover-wrapper blocks-radius we-comparison-table__product-media" style="--aspect-ratio: 1;">',
      `    <img src="${escapeAttr(imgSrc)}" srcset="${escapeAttr(imgSrc)}" alt="${escapeAttr(title)}" width="450" height="450" loading="lazy" class="we-comparison-table__product-img w-full h-full hover-scale-up motion-reduce">`,
      '  </div>',
      '</div>',
      '<div class="comparison-table__col-info text-center">',
      '  <span class="text-pcard-title">',
      `    <a class="block we-comparison-table__product-title" href="${escapeAttr(productUrl)}">`,
      `      <span class="">${escapeHtml(title)}</span>`,
      '    </a>',
      '  </span>',
      buttonHtml,
      '</div>',
      '</div>',
    ].join('');

    return td;
  }

  function escapeAttr(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function injectForContainer(container) {
    const sectionId = container.dataset.sectionId;
    if (!sectionId) return;

    const dataEl = document.getElementById('we-comparison-products-' + sectionId);
    if (!dataEl) return;

    let payload;
    try {
      payload = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    const products = payload.products;

    if (!Array.isArray(products) || products.length === 0) return;

    const showThirdProductColumn =
      payload.showThirdProductColumn !== false &&
      container.dataset.showThirdProductColumn !== 'false';

    const productsToInject = showThirdProductColumn ? products : products.slice(0, 2);

    const section = container.closest('.shopify-section');
    if (!section) return;

    const tbody = section.querySelector('.comparison-table__content tbody');
    if (!tbody) return;

    const tr = document.createElement('tr');
    tr.className = 'we-comparison-table__product-row';

    tr.appendChild(createLabelCell());
    productsToInject.forEach(function (p, index) {
      tr.appendChild(createProductCell(p, index, payload));
    });

    tbody.insertBefore(tr, tbody.firstChild);

    if (!showThirdProductColumn) {
      tbody.querySelectorAll('tr').forEach(function (row) {
        const cells = row.querySelectorAll('td');
        if (cells.length >= 4) {
          cells[3].classList.add('hidden');
        }
      });
    }

    setupProductRowCellStretch(tr);
  }

  function setupScrollFades(container) {
    var content = container.closest('.comparison-table__content');
    if (!content) {
      content = container.parentElement;
    }
    if (!content || !content.classList.contains('comparison-table__content')) return;

    var wrap = content.querySelector('.comparison-table-wrap') || content;
    if (wrap.dataset.weScrollFadeBound === 'true') return;
    wrap.dataset.weScrollFadeBound = 'true';

    function update() {
      var scrolled = wrap.scrollLeft > 2;
      content.classList.toggle('is-scrolled-x', scrolled);
      content.style.setProperty('--comp-fade-left', scrolled ? '1' : '0');
    }

    wrap.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    document.querySelectorAll('[data-we-comparison-inject]').forEach(function (container) {
      injectForContainer(container);
      setupScrollFades(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
